export function resolve(path : string, obj : any) {
	const separator = '.';
	var properties = Array.isArray(path) ? path : path.split(separator);
	// @ts-ignore
	return properties.reduce((previousValue: string, currentValue: number) => previousValue?.[currentValue], obj)
}
